import React from 'react'
import { DomainsTableColumns } from '../../CrossSaleModal.types'
import { CheckBox, StyledText, Switch } from '@clickcease/cc-client-components-lib'

interface DomainCellProps {
  cellType: DomainsTableColumns
  text?: string
  status: boolean
  onChange: () => void
  isDisabled?: boolean
}

export const DomainCellContent = ({
  cellType,
  text,
  status,
  isDisabled,
  onChange,
}: DomainCellProps) => {
  switch (cellType) {
    case 'isSelected':
      return (
        <>
          <CheckBox isChecked={status} onClick={onChange} disabled={isDisabled} />
          <StyledText variant={'baseLight'}>{text}</StyledText>
        </>
      )
    case 'wordpress':
      return <CheckBox isChecked={status} onClick={onChange} disabled={isDisabled} />
    case 'isBzMonitor':
      return <Switch value={status} onChange={onChange} disabled={isDisabled} />
    default:
      return <div></div>
  }
}
